import React from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchItemList,
  DemoWorkbenchStack,
  cssPercentPosition,
} from "@csk/demo-ui";
import {
  FLEET_SPECTRAL_SYSTEMS,
  scatterPoint,
} from "./fleet-comparison-panel/fleetSpectralModel.js";

const FleetComparisonPanel = (): React.JSX.Element => {
  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchCard title="Fleet Spectral Comparison (§13.3)">
        <DemoWorkbenchCopy>
          Fleet systems are clustered by spectral governance fingerprints.
        </DemoWorkbenchCopy>
      </DemoWorkbenchCard>
      <DemoWorkbenchCard compact className="mb-4">
        <div className="relative h-[200px]">
          <div className="text-xs text-gray-500 absolute top-1 left-1">
            MDS projection
          </div>
          {FLEET_SPECTRAL_SYSTEMS.map((s) => {
            const point = scatterPoint(s);
            return (
              <div
                key={s.name}
                className={`absolute w-3 h-3 rounded-full ${s.cluster === 0 ? "bg-green-500" : "bg-red-500"}`}
                style={cssPercentPosition(point.leftPercent, point.topPercent)}
                title={`${s.name}: κ=${s.kappa}, ${s.regime}`}
              />
            );
          })}
        </div>
      </DemoWorkbenchCard>

      <DemoWorkbenchCard compact title="Fleet systems">
        <DemoWorkbenchItemList
          items={FLEET_SPECTRAL_SYSTEMS.map((system) => ({
            id: system.name,
            label: `${system.name} · ${system.regime} · cluster ${system.cluster}`,
            detail: `κ=${system.kappa}`,
            mono: true,
            tone:
              system.regime === "R1"
                ? "success"
                : system.regime === "R2"
                  ? "warning"
                  : "danger",
          }))}
        />
      </DemoWorkbenchCard>

      <DemoWorkbenchCopy size="xs" tone="muted" className="mt-2">
        Systems in the same cluster have similar spectral governance
        fingerprints. A vulnerability in one cluster member is likely in all of
        them.
      </DemoWorkbenchCopy>
    </DemoWorkbenchStack>
  );
};

export default FleetComparisonPanel;
